import { Injectable } from '@angular/core';
import { Features } from '@ordersnproducts/features';
import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';

@Injectable()
export class DcoLogsStatisticsFeature implements IFlagFeature {
  name = Features.DCO_LOGS_STATISTICS;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
